import { ModalScreenLayout as ModalScreen } from "./modal/modal-screen-layout"

export const Layout = {
  ModalScreen
}
